import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import type { PermissionCatalogEntry } from "@forgepoint/shared";

interface PermissionCheckboxGroupProps {
  /** The group heading, e.g. "Quotes" */
  group: string;
  /** The catalog entries belonging to this group */
  entries: PermissionCatalogEntry[];
  /** The currently selected permission slugs */
  selected: Set<string>;
  /** Called when a permission is checked or unchecked */
  onToggle: (slug: string, checked: boolean) => void;
  /** Disables all checkboxes (e.g. while saving or for default roles) */
  disabled?: boolean;
}

/**
 * One labelled group of permission checkboxes for the role editor sheet.
 * @param props - PermissionCheckboxGroupProps
 * @returns Permission checkbox group element
 */
export function PermissionCheckboxGroup({
  group,
  entries,
  selected,
  onToggle,
  disabled,
}: PermissionCheckboxGroupProps) {
  return (
    <div className="space-y-2">
      <p className="text-sm font-medium">{group}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2">
        {entries.map((entry) => (
          <div key={entry.slug} className="flex items-center gap-2">
            <Checkbox
              id={`permission-${entry.slug}`}
              checked={selected.has(entry.slug)}
              onCheckedChange={(checked) =>
                onToggle(entry.slug, checked === true)
              }
              disabled={disabled}
            />
            <Label
              htmlFor={`permission-${entry.slug}`}
              className="text-sm font-normal"
            >
              {entry.label}
            </Label>
          </div>
        ))}
      </div>
    </div>
  );
}
